<script setup lang="ts">
import { useAttrs } from 'vue'

defineProps({
  itemsList: Array as any
})
// defineProps({
//   itemsList:  Array<Object>
// })

const attrs$ = useAttrs()
</script>

<template>
  <div v-bind="attrs$" class="def:flex def:flex-row def:gap-x-9 def:justify-center def:pt-20">
    <template v-for="item in itemsList">
      <slot :item="item"></slot>
    </template>
  </div>
</template>
